
import { AuthUser } from './types';
import { normalizeEmail } from './permissions';

export const getStoredAuth = (): { user: AuthUser | null; token: string | null } => {
  try {
    const storedUser = localStorage.getItem('auth_user');
    const storedToken = localStorage.getItem('auth_token');
    
    console.log('🔍 Verificando autenticação armazenada:', { storedUser: !!storedUser, storedToken: !!storedToken });
    
    if (storedUser && storedToken) {
      const user = JSON.parse(storedUser);
      console.log('✅ Usuário encontrado no localStorage:', user);
      return { user: { ...user, token: storedToken }, token: storedToken };
    } else {
      console.log('❌ Nenhum usuário encontrado no localStorage');
      return { user: null, token: null };
    }
  } catch (error) {
    console.error('Erro ao verificar autenticação armazenada:', error);
    return { user: null, token: null };
  }
};

export const storeAuth = (user: AuthUser): void => {
  try {
    localStorage.setItem('auth_user', JSON.stringify({
      id: user.id,
      nome: user.nome,
      email: normalizeEmail(user.email) || user.email || '',
      permissoes: user.permissoes,
      perfil_padrao: user.perfil_padrao,
      origem: user.origem
    }));
    localStorage.setItem('auth_token', user.token);
  } catch (error) {
    console.error('Erro ao armazenar dados de autenticação:', error);
  }
};

export const clearAuth = (): void => {
  try {
    localStorage.removeItem('auth_user');
    localStorage.removeItem('auth_token');
  } catch (error) {
    console.error('Erro ao limpar dados de autenticação:', error);
  }
};
